module.exports = __webpack_public_path__ + "static/dipartimento-protezione-civile-233af24bd099110d6942fc211a1fa597.svg";